"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
function Alert(props) {
    return react_1.default.createElement(Alert_1.default, Object.assign({ elevation: 6, variant: "filled" }, props));
}
const SnackBar = (props) => {
    const { snackbar } = props;
    const open = !!(snackbar.type && snackbar.text);
    const handleClose = () => {
        props.triggerModal({
            root: '',
            key: 'snackbar',
            val: {
                type: null,
                text: null
            },
        });
    };
    return snackbar.type && snackbar.text && (react_1.default.createElement(core_1.Snackbar, { open: open, autoHideDuration: 3000, onClose: handleClose },
        react_1.default.createElement(Alert, { onClose: handleClose, severity: snackbar.type }, snackbar.text)));
};
const mapStateToProps = (state) => {
    const { modals } = state;
    return {
        snackbar: modals.snackbar,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SnackBar);
